<template>
  <!-- section -->
  <div v-show="!hidden" class="formGroup isRequired mt15">
    <label class="label toCapitalize notranslate">{{locale.reservation_section}}</label>
    <select class="input" v-model="section" @change="selectSection">
      <option value="" disabled class="notranslate toCapitalize">{{locale.select_section}}</option>
      <option
        v-for="s in sectionInfo"
        :key="s.id"
        :value="s.id"
        :disabled="s.disabled">
        {{s.name[lang]}}
      </option>
    </select>
  </div>
  <!-- //section -->
</template>

<script>
import moment from 'moment/moment'
import regExp from '@/common/regExp'
import Summary from '@/components/Reservation/Summary'
import SeatMap from '@/components/Reservation/SeatMap'

export default {
  name: 'ReservationFormSection',
  props: [
    'lang',
    'ln',
    'locale',
    'info',
    'roomKey',
    'rid',
    'isPublic',
    'sectionInfo'
  ],
  components: {
    Summary,
    SeatMap
  },
  computed: {
    current () {
      const list = this.sectionInfo
      return list && list.find(x => x.id === this.section)
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.sectionInfo && this.sectionInfo.length === 1) {
        this.section = this.sectionInfo[0].id
        this.selectSection()
        this.hidden = true
      }
    })
  },
  beforeDestroy () {
    this.section = null
    this.selectSection()
  },
  data () {
    return {
      hidden: false,
      section: ''
    }
  },
  methods: {
    selectSection () {
      this.$emit('setSection', this.section)
    }
  }
}
</script>
